import '../reader/practice'
import '../reader/progress'
import '../reader/live_practice'

$(document).on("click", '#sidebar-button', function(){
    let sidebar = $("#sidebar");
    if($('.sidebar-open').hasClass('opacity-0')){
        $('.sidebar-close').addClass('opacity-0 scale-80')
        $('.sidebar-open').removeClass('opacity-0 scale-80')
        sidebar.addClass("hidden");
    } else {
        $('.sidebar-open').addClass('opacity-0 scale-80')
        $('.sidebar-close').removeClass('opacity-0 scale-80')
        sidebar.removeClass("hidden");
    }
});

window.loadJS = function(url, implementationCode, location){
    let scriptTag = document.createElement('script');
    scriptTag.src = url;

    scriptTag.onload = implementationCode;
    scriptTag.onreadystatechange = implementationCode;

    location.appendChild(scriptTag);
};

window.loadCss = function(url) {
    return new Promise((resolve, reject) => {
        let link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.onload = function() { resolve(); };
        link.href = url;

        let headScript = document.querySelector('script');
        headScript.parentNode.insertBefore(link, headScript);
    });
};


window.loadMathJax = function(){
    let body = $("body").text();

    const patterns = [
        /\$\$.*?\$\$/,   
        /\$.*?\$/,
    ];

    for (const pattern of patterns) {
        if (pattern.test(body)) {
            if (!window.MathJax) {
                window.MathJax = {"HTML-CSS": { preferredFont: "TeX", availableFonts: ["STIX","TeX"], linebreaks: { automatic:true } },
                    tex2jax: { inlineMath: [ ["$", "$"], ["\\\\(","\\\\)"] ], displayMath: [ ["$$","$$"], ["\\[", "\\]"] ], processEscapes: true, ignoreClass: "tex2jax_ignore|dno" },
                    TeX: {  noUndefined: { attributes: { mathcolor: "red", mathbackground: "#FFEEEE", mathsize: "90%" } }, Macros: { href: "{}" } },
                    messageStyle: "none", showMathMenu:false,
                }
    
    
                let script = document.createElement('script');
                script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.9/MathJax.js?config=TeX-AMS_HTML-full';
                document.head.appendChild(script);
            } else {
                MathJax.Hub.Queue(['Typeset', MathJax.Hub]);
            }
            break;
        }
    }
}

window.loadCodeHighlight = async function(){
    let codeElements = $("code");

    if(codeElements.length > 0) {
        await loadCss("//cdnjs.cloudflare.com/ajax/libs/highlight.js/11.3.1/styles/atom-one-dark.min.css");
        loadJS("//cdnjs.cloudflare.com/ajax/libs/highlight.js/11.3.1/highlight.min.js", function(){
            document.querySelectorAll('pre code').forEach(el => {
                hljs.highlightElement(el);
            });
        }, document.body);
    }
}

$(document).ready(function () {
    // load mathjax only if math block is present
    loadMathJax();
    loadCodeHighlight();
});